import React, { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
// Facebook Pixel
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
!function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
}(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
window.fbq('init', '1470453737992181');
window.fbq('track', 'PageView');
window.fbq('track', 'ViewContent', {
  content_name: 'Método Dormir sin Lágrimas',
  content_type: 'product',
  value: 14990,
  currency: 'ARS'
});
const noscriptImg = document.createElement('img');
noscriptImg.height = 1;
noscriptImg.width = 1;
noscriptImg.style.display = 'none';
noscriptImg.src = 'https://www.facebook.com/tr?id=1470453737992181&ev=PageView&noscript=1';
document.body.appendChild(noscriptImg);
const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<React.StrictMode data-id="element-251">
      <App data-id="element-252" />
    </React.StrictMode>);
}